import { render, staticRenderFns } from "./Article.pug?vue&type=template&id=071e2c33&lang=pug&external"
import script from "./Article.js?vue&type=script&lang=js&external"
export * from "./Article.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports